import { Directive } from "@angular/core";
import { CdkDragPlaceholder } from "@angular/cdk/drag-drop";

@Directive({
    selector: "[wkDragPlaceholder]",
    hostDirectives: [CdkDragPlaceholder],
})
export class DragPlaceholderDirective {}
